import { gql } from '@apollo/client';
const REMOVE_TENANT_CATEGORY = gql `
  mutation RemoveTenantCategory($categoryId: ID!) {
    removeModelSpecificationCategory(modelSpecificationCategoryId: $categoryId) {
      removed
    }
  }
`;
export default REMOVE_TENANT_CATEGORY;
